import { useEffect, useRef, useState } from "react";

const checklist = [
  { label: "Feel stiff after sitting", checked: true },
  { label: "Over 50", checked: true },
  { label: "Want to stay active", checked: true },
  { label: "Want greater mobility", checked: true },
  { label: "Value independence", checked: true },
  { label: "Looking for nutritional support", checked: true },
];

export default function SelfAssessment() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-8 lg:px-12">
        <div
          className={`text-center mb-10 md:mb-14 transition-all duration-600 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
          }`}
          style={{ transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)" }}
        >
          <p className="text-accent-500 text-base font-medium tracking-[0.2em] uppercase mb-3">
            Self-Assessment
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Is Joint Genesis Right For You?
          </h2>
          <p className="text-foreground-700 text-xl max-w-2xl mx-auto">
            A short editorial checklist to help you decide whether this kind of
            nutritional support fits your lifestyle.
          </p>
        </div>

        <div
          className={`rounded-xl border border-background-200/70 bg-background-100 p-6 md:p-10 transition-all duration-600 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
          }`}
          style={{ transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)" }}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {checklist.map((item, idx) => (
              <div
                key={item.label}
                className={`flex items-center gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70 card-hover-lift transition-all duration-600 ${
                  visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
                }`}
                style={{
                  transitionDelay: `${idx * 80}ms`,
                  transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)",
                }}
              >
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0">
                  <i className="ri-check-line text-base" />
                </div>
                <span className="text-foreground-800 text-lg font-medium">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}